import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const MovePosition = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M12.5148 4L15.5148 7L12.5148 10" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M4.5 16.5147L4.5 13C4.5 9.6863 7.18629 7 10.5 7L14.0147 7" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default MovePosition;